<template>
    <div class="main">
        <report-top>
            <ly-search slot="search" v-model="searchItem.keyWork" @search="search"></ly-search></report-top>


        <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
            :height="utils.setTableHeight(160)">

            <template slot-scope="{ row, index }" slot="icon">
                <img :src="axios.platConfig.fileUri + 'mapicon/' + row.icon + '/4/1.gif'" style="width: 30px" />
            </template>

            <template slot-scope="{ row, index }" slot="action">
                <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
                <Button size="small" @click="del(row, 1)">删除</Button>
            </template>
        </Table>
        <div id="mypage">
            <div>
                <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]"
                    show-total show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange">
                </Page>
            </div>
        </div>

    </div>
</template>

<script>
var categorys = [];
export default {
    data() {
        return {
            isAdd: false,
            columns: [
                {
                    type: "index",
                    width: 70,
                    align: "center",
                    sort: 0,
                },
                {
                    title: "外币名称",
                    key: "fromName",

                },
                {
                    title: "本币名称",
                    key: "toName",
                },
                {
                    title: "汇率",
                    key: "rate",
                }, 
                {
                    title: "更新时间",
                    key: "updateTime2",
                },
                {
                    title: "备注信息",
                    key: "remark",
                },

            ],
            tableData: [],
            item: {
                name: "",
                icon: "car",
                remark: "",
                category: "其他类",
                type: "0",
                sort: 1,
                carNo: "",
                carId: "",
                extend: {
                    kgs: 0,
                    cbm: 0,
                    pl: 0,
                },
                extend_kgs: 2000,
                extend_cbm: 13,
                extend_pl: 12,
            },

            searchItem: {
                "pageNumber": 1,
                "pageSize": 50,
                "type": 0,
                "cid": null,
                keyWork: ''
            },
            searchForms: [
                /* {
                   title: "类型分类",
                   key: "categorys",
                   type: "Select",
                   selectItems: categorys,
                 },
                  {
                   title: "时间范围",
                   key: "startTime",
                   key1: "endTime",
                   type: "lyyymmdd",
                   times: "2,0",
                 }, */
            ],
            total: 0,
            categorys: [],
            forms: [


            ],
        };
    },
    methods: {
        getList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-tms-server-base/rate/list",
                data: this.searchItem,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;
                for (let i = 0; i < data.length; i++) {
                    data[i].toName = '人民币';
                    data[i].updateTime2 = this.utils.time(data[i].updateTime)

                }
                this.tableData = data;
            });
        },


        changePage(x) {
            this.searchItem.pageNumber = x;
            this.getList();
        },
        //每页总条数切换
        pageSizeChange(x) {
            this.searchItem.pageSize = x;
            this.getList();
        },
        search() {
            this.getList();
        },
        //carTypeCategory
        getDictionary() {
            this.axios({
                method: "post",
                url: "/dictionary/item",
                data: {
                    keyword: "carTypeCategory",
                },
            }).then((res) => {
                var a = JSON.parse(res.data.data.value);
                categorys.splice(0, 100);
                for (const i in a) {
                    categorys.push(a[i].name);
                }
            });
        },
        selectCartype(x) {
            this.selectIcon = x.value;
        },
        getSearchItem() {
            this.searchItem = this.$refs.selectTool.getItem();
            this.getList();
        },
    },
    mounted() {
        var config = {
            min: 100,
            max: 300,
        };
        this.columns = this.utils.cols(this.forms, this.columns);
        this.getList()
    },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/huilvgonggong.vue